import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  CardHeader,
  CardContent,
  Stack,
  Button,
  Box,
  Divider,
  Avatar,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import GiftServiceApi from "../../services/GiftService";

const VirtualGiftView = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();
  console.log("id",id);

  useEffect(() => {
    const fetchData = async () => {
        // const selectedData = mockData.find((item) => item._id === id); // Filter mockData based on id
        // setData(selectedData);
      try {
        const response = await GiftServiceApi.getOneGift({ id: id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Box>
      <Helmet>
        <title>Virtual Gift</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="Gift View" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Box display="flex" justifyContent="center" mb={2}>
                    {console.log("sdd",IMAGE_BASE + data?.giftImage)}
                    <Avatar
                      src={IMAGE_BASE + data?.giftImage}
                      alt="Profile Icon"
                      sx={{ width: 100, height: 100 }}
                    />
                  </Box>

                  <Stack spacing={2}>
                    <Typography variant="h6">Name</Typography>
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {data?.title || ""}
                    </Typography>
                    <Divider></Divider>

                    <Typography variant="h6">Coins</Typography>
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {data?.coins || ""}
                    </Typography>
                    <Divider></Divider>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default VirtualGiftView;
